const getCookie = () => {
  return localStorage.getItem('720yun_v8_token') || '';
};

export default getCookie;
